import { invokeApi } from "../../bl_libs/invokeApi";

const getAuthHeader = () => ({
  "x-sh-auth": localStorage.getItem("token"),
});

// ── Flight School ──────────────────────────────────────────────────────────────

export const create_stripe_customer_api = async (name, email) => {
  const requestObj = {
    path: "api/stripe/create_customer",
    method: "POST",
    headers: getAuthHeader(),
    postData: { name, email },
  };
  return invokeApi(requestObj);
};

// ── User / Member ──────────────────────────────────────────────────────────────

export const get_user_stripe_details_api = async (stripeCustomerId) => {
  const requestObj = {
    path: `api/stripe/user_details/${stripeCustomerId}`,
    method: "GET",
    headers: getAuthHeader(),
  };
  return invokeApi(requestObj);
};

export const admin_grant_trial_api = async (userId, trialDays, priceId) => {
  const requestObj = {
    path: "api/stripe/admin_grant_trial",
    method: "POST",
    headers: getAuthHeader(),
    postData: { userId, trialDays, priceId },
  };
  return invokeApi(requestObj);
};

export const admin_change_plan_api = async (userId, priceId) => {
  const requestObj = {
    path: "api/stripe/admin_change_plan",
    method: "POST",
    headers: getAuthHeader(),
    postData: { userId, priceId },
  };
  return invokeApi(requestObj);
};

export const admin_cancel_subscription_api = async (userId, cancelImmediately) => {
  const requestObj = {
    path: "api/stripe/admin_cancel_subscription",
    method: "POST",
    headers: getAuthHeader(),
    postData: { userId, cancelImmediately },
  };
  return invokeApi(requestObj);
};

// ── Insurance ──────────────────────────────────────────────────────────────────

export const admin_get_user_insurance_api = async (userId) => {
  const requestObj = {
    path: `api/insurance/admin_get/${userId}`,
    method: "GET",
    headers: getAuthHeader(),
  };
  return invokeApi(requestObj);
};

export const admin_activate_insurance_api = async (userId) => {
  const requestObj = {
    path: "api/insurance/admin_activate",
    method: "POST",
    headers: getAuthHeader(),
    postData: { userId },
  };
  return invokeApi(requestObj);
};

export const admin_cancel_insurance_api = async (userId) => {
  const requestObj = {
    path: "api/insurance/admin_cancel",
    method: "POST",
    headers: getAuthHeader(),
    postData: { userId },
  };
  return invokeApi(requestObj);
};
